/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-09 10:23:03
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-09 10:24:35
 * @FilePath: \goodmanger\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
